import { Helmet } from 'react-helmet';
import {
    Avatar,
    Box, Button, Card, CardContent,
    Container, Divider,
    Grid, Tab, Tabs, Toolbar, Typography, tableCellClasses, ClickAwayListener, Rating, MenuItem, Select, TextField, InputAdornment
} from '@mui/material';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import axios from "axios";
import cssVariables from "../../../theme/cssVariables";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { makeStyles, styled } from "@mui/styles";
import exports from "../../../assets/images/export.png";
import teamMember from "../../../assets/images/viewDashboard.svg";
import emty from "../../../assets/images/emty.png";
import { ReactComponent as ListFile } from "../../../assets/images/listFile.svg";
import { ReactComponent as TooltipIcon } from "../../../assets/images/tooltip.svg";
import { ReactComponent as BtnFilter } from "../../../assets/images/btn-filter.svg";
import { ReactComponent as ArrowRight } from "../../../assets/images/conpetency-arrow-right.svg";
import core from "../../../assets/images/core.svg";
import functional from "../../../assets/images/Functional.svg";
import managerial from "../../../assets/images/Managerial.svg";
import { useParams } from "react-router-dom";
import Search from "@mui/icons-material/Search";
import MenuFilter from "../../../components/kpi/MenuFilter";
import myCompetencies from "../../../icons/myCompetencies.png";
import competencyService from "../../../services/competency.service";
import Icon from '@mui/material/Icon';
import fileBrowser from "../../../icons/file-browser.svg";
import * as Util from "../../../services/global.service";

import EvaluationRatio from "../../../components/baseComponent/EvaluationRatio";


const styles = {
    path: {
        color: "#68717A",
    },
    paPlanning: {
        marginTop: "-12px",
        marginLeft: "19px",
    },
    icon: {
        color: "#6B6B6B",
        marginBottom: "-3px",
        marginRight: "10px",
    },
    lastToolBar: {
        marginTop: "0px",
    },
    blueBadge: {
        background: "rgba(93, 161, 150, 0.15)",
        padding: "5px 12px",
        color: "#5DA196",
        border: "1px solid #5DA196",
        borderRadius: "4px"
    },
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
    colorText: {
        color: "#404349",
        fontWeight: "400",
        paddingLeft: "10px"
    },
    box: {
        width: "calc(50% - 30px)",
        "flex-direction": "row",
        margin: "15px 15px",
        cursor: "pointer",
    },
    content: {
        background: "#FFFFFF",
        "box-shadow": "0px 0px 5px rgba(0, 0, 0, 0.1)",
        "border-radius": "10px",
        padding: "17px 22px",
        height: "100%",
    },
    emty: {
        display: "flex",
        "flex-flow": "column wrap",
        "background-color": "#fff",
        height: "220px",
        "box-shadow": "0px 0px 5px rgb(0 0 0 / 10%)",
        "border-radius": "10px",
        "justify-content": "center",
        "align-items": "center",
    },
    twoContent: {
        display: "flex",
        "justify-content": "center",
        "flex-direction": "row",
        "align-items": "center",
    },
    boxTwoContent: {
        display: "flex",
        "justify-content": "space-between",
        "flex-direction": "row",
        "align-items": "center",
    }
};

const Planing = () => {
    const _ = require('lodash');
    const { t } = useTranslation();
    const dispatch = useDispatch();
    let { serial } = useParams();
    const [value, setValue] = React.useState('all');
    const [valueSerial, setValueSerial] = React.useState('');
    const [open, setOpen] = React.useState(false);
    const [evaluated, setEvaluated] = React.useState(true);
    const [notEvaluated, setNotEvaluated] = React.useState(true);
    const [openMenu, setOpenMenu] = React.useState(false);
    const [competencyFormSelect, setCompetencyForm] = React.useState([]);
    const [competencyFormSelectValue, setCompetencyFormValue] = React.useState("");
    const [dataCustomize, setDataCustomize] = React.useState({});
    // redux state
    const planning = useSelector((state) => state.Planning);
    const [search, setSearchValue] = React.useState("");
    const handleSearch = (event) => {
        setSearchValue(event.target.value);
    };
    useEffect(() => {
        dataSerachs()
    }, [search, notEvaluated, evaluated]);
    const handleChangeWorkloadForm = (event) => {
        setCompetencyFormValue(event.target.value);
    };

    const dataSerachs = async () => {
        let result = {}
        let dataSerach = JSON.parse(JSON.stringify(mainData?.list ? mainData.list : null))
        if (search !== "" && dataSerach !== undefined && Object.keys(dataSerach).length > 0) {
            for (let index = 0; index <= Object.keys(dataSerach).length - 1; index++) {
                let resultData = dataSerach[Object.keys(dataSerach)[index]].filter(rs => {
                    return Object.keys(rs).some(key => {
                        if (key === 'name' || key === 'code' || key === 'category') {
                            return rs[key].toString().toLowerCase().indexOf(search.toString().toLowerCase()) !== -1;
                        }
                        if (key === 'proficiency') {
                            if (rs[key] !== undefined && rs[key] !== null && rs[key] !== "") {
                                return Object.keys(rs[key]).some(keys => {
                                    return rs[key][keys].toString().toLowerCase().indexOf(search.toString().toLowerCase()) !== -1;
                                });
                            }

                        }
                    });
                });
                result[Object.keys(dataSerach)[index]] = resultData
            }
        } else {
            result = dataSerach;
        }
        await filterEvaluatedSerach({ ...mainData, list: result })
    };

    const [mainData, setMainData] = React.useState({});
    const [filterData, setFilterData] = React.useState({});
    let getDataCompetency = (data) => {
        let pathData = ""
        if (formatData(data, false) !== false && formatData(serial, false) !== false) {
            pathData = `app/kpi/competency?kpi_form_id=${data}&employee_id=${serial}`
        } else {
            if (formatData(data, false) !== false) {
                pathData = `app/kpi/competency?kpi_form_id=${data}`
            }
            if (formatData(serial, false) !== false) {
                pathData = `app/kpi/competency?employee_id=${serial}`
            }
        }
        competencyService.competency(pathData).then(
            (response) => {
                if (response?.data !== undefined && Object.keys(response.data).length > 0) {
                    setMainData(response.data)
                    setFilterData(response.data)

                    if (response?.custom) setDataCustomize(response?.custom)
                }
            },
        );
    }
    let getDataCompetencyYear = () => {
        if (formatData(serial, false) !== false) {
            console.log(456);
            competencyService.competencyYear(serial).then(
                (response) => {
                    if (response?.data !== undefined && response.data.length > 0) {
                        setCompetencyForm(response.data)
                        let filterData = response.data.filter((e) => e.is_default === true)
                        if (filterData.length > 0) {
                            setCompetencyFormValue(filterData[0].value)
                        } else {
                            setCompetencyFormValue(response.data[0].value)
                        }
                    }
                },
            );
        } else {
            console.log(45644);
            competencyService.competencyYear().then(
                (response) => {
                    if (response?.data !== undefined && response.data.length > 0) {
                        setCompetencyForm(response.data)
                        let filterData = response.data.filter((e) => e.is_default === true)
                        if (filterData.length > 0) {
                            setCompetencyFormValue(filterData[0].value)
                        } else {
                            setCompetencyFormValue(response.data[0].value)
                        }
                    }
                },
            );
        }
    }

    const handleTooltipOpen = (data) => {
        if (data !== valueSerial) {
            setOpen(true)
            setValueSerial(data)
        } else {
            setOpen(false)
            setValueSerial("")
        }
    };
    const BootstrapTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} arrow classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.arrow}`]: {
            color: "#343A40",
        },
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: "#343A40",
            color: "#FFFFFF",
            padding: "11px 15px",
        },
    }));

    const Root = styled('div')(({ theme }) => ({
        display: "flex", paddingTop: "30px", margin: "0 15px",
        ['@media (max-width:780px)']: {
            width: "calc(100% - 30px)",
        },
        ['@media (min-width:781px)']: {
            width: "calc(50% - 30px)",
        },
        ['@media (min-width:1000px)']: {
            width: "calc(25% - 30px)",
        },
    }));

    const tabs = _.groupBy(planning.rubrics, function (loRow) {
        return loRow.rubricCat;
    })

    const sumData = () => {
        let sum = 0
        if (mainData?.competency_type !== undefined && mainData?.competency_type !== null && mainData?.competency_type.length > 0) {
            mainData.competency_type.map((loRow) => { sum = sum + loRow?.total })
        }
        return sum
    }

    useEffect(() => {
        getDataCompetencyYear()
    }, []);

    useEffect(() => {
        if (competencyFormSelectValue !== null && competencyFormSelectValue !== undefined && competencyFormSelectValue !== "") {
            getDataCompetency(competencyFormSelectValue)
        }
    }, [competencyFormSelectValue]);

    useEffect(() => {
        let maybeHandler = (event) => {
            if (event.target.closest(".tooltip") === null) {
                setOpen(false)
                setValueSerial("")
            }
        };

        document.addEventListener("click", maybeHandler);

        return () => {
            document.removeEventListener("click", maybeHandler);
        };
    });

    const filterEvaluatedSerach = (data) => {
        let result = {}
        let dataFilter = JSON.parse(JSON.stringify(data.list))
        if (notEvaluated === false && evaluated === false) {
            setFilterData({ ...data, list: {} })
        } else if (notEvaluated === true && evaluated === true) {
            setFilterData(data)
        } else {
            console.log(dataFilter);
            if (notEvaluated === true) {
                for (let index = 0; index <= Object.keys(dataFilter).length - 1; index++) {
                    let resultData = dataFilter[Object.keys(dataFilter)[index]].filter(rs => rs?.is_evaluate === false);
                    result[Object.keys(dataFilter)[index]] = resultData
                }
                setFilterData({ ...mainData, list: result })
            } else if (evaluated === true) {
                for (let index = 0; index <= Object.keys(dataFilter).length - 1; index++) {
                    let resultData = dataFilter[Object.keys(dataFilter)[index]].filter(rs => rs?.is_evaluate === true);
                    result[Object.keys(dataFilter)[index]] = resultData
                }
                setFilterData({ ...mainData, list: result })
            }
        }
    };

    const StyledRating = styled(Rating)({
        '& .MuiRating-icon': {
            color: "#F7B254 !important"
        },
    });

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const useStyles = makeStyles({
        root: {
            'border-width': 0,
            'padding-left': 0,
            [`&.${tableCellClasses.body}`]: {
                'border-width': 0,
                'padding-left': 0,
            }
        },
        tab: {
            fontSize: "16px !important",
            fontWeight: "400 !important",
            '&.Mui-selected': {
                color: cssVariables.color.primary + " !important"
            },
            '&.MuiTab-root': {
                color: "#A3A3A3",
                "text-transform": "none"
            }
        },
        profileContainer: {
            width: 70,
            height: 70,
            borderRadius: "50%",
            marginTop: 3,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
    })
    const classes = useStyles();
    const navigate = useNavigate();
    const clickLink = (data) => {
        navigate(data, { replace: false });
    }

    const formatData = (data, defaults) => {
        if (data !== null && data !== undefined && data !== "") {
            return data;
        }
        return defaults;
    }
    const EditNotEvaluated = (data) => {
        if (data === "notEvaluated") {
            setNotEvaluated(!notEvaluated)
        } else if (data === "evaluated") {
            setEvaluated(!evaluated)
        } else if (data === "selectAll") {
            if (notEvaluated === true && evaluated === true) {
                setNotEvaluated(false)
                setEvaluated(false)
            } else if (notEvaluated === false && evaluated === false) {
                setNotEvaluated(true)
                setEvaluated(true)
            } else if (notEvaluated === true || evaluated === true) {
                setNotEvaluated(true)
                setEvaluated(true)
            }
        }
    };
    const onScroll = (evt) => {
        if (evt !== undefined && evt !== null) {
            if (openMenu) {
                setOpenMenu(false)
            }
        }
    }
    const statusOpen = (data) => {
        setOpenMenu(data)
    }
    const openTeamMember = (val) => {
        const newWindow = window.open('/kpi/team-member', '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
    }

    return (
        <Box onScroll={onScroll} className="asd" style={{ "max-height": "100%", "overflow-y": "auto" }}>
            <Helmet>
                <title>HOME | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    py: 3
                }}
            >
                <Container maxWidth="xl">
                    <Grid container pt={2} pb={2}>
                        {mainData?.is_owner === false ?
                            <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/kpi/home')}>{t('label.home')}</span> / <span style={styles.link} onClick={() => clickLink('/kpi/team-member')}>{t('competency.teamMember')}</span> / <span style={styles.end} >{formatData(mainData?.owner_profile?.fullname, "-")}</span></Typography>
                            : mainData?.is_owner === true ?
                                <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/kpi/home')}>{t('label.home')}</span> / <span style={styles.end} >{t('competency.myName')}</span></Typography>
                                : formatData(serial, false) === false ?
                                    <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/kpi/home')}>{t('label.home')}</span> / <span style={styles.end} >{t('competency.myName')}</span></Typography> :
                                    <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/kpi/home')}>{t('label.home')}</span> / <span style={styles.link} onClick={() => clickLink('/kpi/team-member')}>{t('competency.teamMember')}</span> / <span style={styles.end} >{t('competency.name')}</span></Typography>
                        }
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid container item >
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                                <Typography variant="h2" color="#404349" fontSize={36} lineHeight="40px" pb={mainData?.is_owner ? "20px" : "0px"}>
                                    {mainData?.is_owner ? t('competency.myName') : t('competency.name')}
                                </Typography>
                                {mainData?.is_owner === false ?
                                    <Box
                                        display="flex"
                                        alignItems="flex-start"
                                        justifyContent="flex-start"
                                        flexDirection="row"
                                    >
                                        <Select
                                            id="workload-select"
                                            inputlabelprops={{ shrink: false }}
                                            variant="outlined"
                                            size="small"
                                            sx={{ width: "400px" }}
                                            className="white-bg"
                                            value={competencyFormSelectValue}
                                            onChange={handleChangeWorkloadForm}
                                        >
                                            {
                                                competencyFormSelect?.length > 0 ?
                                                    competencyFormSelect.map(item => {
                                                        return (
                                                            <MenuItem value={item.value} key={item.value}>
                                                                {item.name}
                                                            </MenuItem>
                                                        )
                                                    })

                                                    : <MenuItem value="">
                                                        ---{t('label.notFund')}---
                                                    </MenuItem>
                                            }
                                        </Select>
                                    </Box>
                                    : null}
                                {mainData?.is_owner === undefined && competencyFormSelect.length > 0 ?
                                    <Box
                                        display="flex"
                                        alignItems="flex-start"
                                        justifyContent="flex-start"
                                        flexDirection="row"
                                    >
                                        <Select
                                            id="workload-select"
                                            inputlabelprops={{ shrink: false }}
                                            variant="outlined"
                                            size="small"
                                            sx={{ width: "400px" }}
                                            className="white-bg"
                                            value={competencyFormSelectValue}
                                            onChange={handleChangeWorkloadForm}
                                        >
                                            {
                                                competencyFormSelect?.length > 0 ?
                                                    competencyFormSelect.map(item => {
                                                        return (
                                                            <MenuItem value={item.value} key={item.value}>
                                                                {item.name}
                                                            </MenuItem>
                                                        )
                                                    })

                                                    : <MenuItem value="">
                                                        ---{t('label.notFund')}---
                                                    </MenuItem>
                                            }
                                        </Select>
                                    </Box>
                                    : null}
                            </Box>
                            <Grid item md={12} xs={12}>
                                {mainData?.is_owner ?
                                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                        <Box
                                            display="flex"
                                            alignItems="flex-start"
                                            justifyContent="flex-start"
                                            flexDirection="row"
                                        >
                                            <Select
                                                id="workload-select"
                                                inputlabelprops={{ shrink: false }}
                                                variant="outlined"
                                                size="small"
                                                sx={{ width: "400px" }}
                                                className="white-bg"
                                                value={competencyFormSelectValue}
                                                onChange={handleChangeWorkloadForm}
                                            >
                                                {
                                                    competencyFormSelect?.length > 0 ?
                                                        competencyFormSelect.map(item => {
                                                            return (
                                                                <MenuItem value={item.value} key={item.value}>
                                                                    {item.name}
                                                                </MenuItem>
                                                            )
                                                        })

                                                        : <MenuItem value="">
                                                            ---{t('label.notFund')}---
                                                        </MenuItem>
                                                }
                                            </Select>
                                        </Box>
                                        <Box sx={{ flex: 2 }}></Box>
                                        {mainData?.is_manager ?
                                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                <Box pl="35px">
                                                    <Button sx={{ display: "flex", height: "45px", "text-transform": "none" }} onClick={e => openTeamMember()} variant="dashed-solid" ><Box sx={{ display: "flex", "align-items": "center" }}><img style={{ display: "block", "margin-right": "10px" }} src={teamMember} alt="export"></img><Typography color="#393939">{t('competency.teamMember')}</Typography></Box></Button>
                                                </Box>
                                            </Box>
                                            : null}
                                        {/* <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                            <Box pl="35px">
                                                <Button sx={{ display: "flex", height: "45px", "text-transform": "none" }} variant="dashed-solid" ><Box sx={{ display: "flex", "align-items": "center" }}><img style={{ display: "block", "margin-right": "10px" }} src={exports} alt="export"></img><Typography color="#393939">{t('label.exportReport')}</Typography></Box></Button>
                                            </Box>
                                        </Box> */}
                                    </Box>
                                    : null}
                                {mainData?.is_owner === false ?
                                    <Grid container item pt="30px">
                                        <Grid item xs sm md lg>
                                            <Card sx={{ height: 1 }}>
                                                <CardContent sx={{ px: 2 }}>
                                                    <Grid container mb={2}>
                                                        <Grid item lg={6} xs={7} display="flex" alignItems="center">
                                                            <Typography variant="h3">{t('label.myProfile')}</Typography>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container>
                                                        <Grid
                                                            item
                                                            display="flex"
                                                            justifyContent="center"
                                                            alignItems="center"
                                                            mr={3}
                                                        >
                                                            <Avatar
                                                                src={mainData?.owner_profile?.photo}
                                                                sx={{
                                                                    cursor: "pointer",
                                                                    width: 80,
                                                                    height: 80,
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs sm md lg>
                                                            <Grid container>
                                                                <Grid item xs sm md={12}>
                                                                    <Typography variant="h5" color="primary">
                                                                        {formatData(mainData?.owner_profile?.fullname, "-")}
                                                                    </Typography>
                                                                </Grid>
                                                                {/* <Grid item xs sm md={6}>
                                                                    <Typography variant="sub_label" color="#404349">{t('label.team')}: {formatData(mainData?.owner_profile?.team, "-")}</Typography>
                                                                </Grid> */}
                                                            </Grid>
                                                            <Grid container>
                                                                <Grid item xs sm md={6} >
                                                                    <Typography variant="sub_label" color="#404349">{formatData(mainData?.owner_profile?.position, "-")}</Typography>
                                                                </Grid>
                                                                <Grid item xs sm md={6} >
                                                                    <Typography variant="sub_label" color="#404349">{t('label.team')}: {formatData(mainData?.owner_profile?.organization, "-")}</Typography>
                                                                </Grid>
                                                            </Grid>
                                                            <Grid container>
                                                                <Grid item xs sm md={6} >
                                                                    <Typography variant="sub_label" color="#404349">{t('label.employeeID')}: {formatData(mainData?.owner_profile?.code, "-")}</Typography>
                                                                </Grid>
                                                                <Grid item xs sm md={6} >
                                                                    <Typography variant="sub_label" color="#404349">{t('label.joinedDate')}: {formatData(mainData?.owner_profile?.joined_date, "-") === "-" ? "-" : `${Util.dateDayFormat(mainData?.owner_profile?.joined_date)}`}</Typography>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    </Grid>
                                    : null}
                            </Grid>
                        </Grid>

                        <Grid container pt="18px" sx={{ "flex-wrap": "nowrap !important" }}>
                            <Box width={((dataCustomize?.allcomponentcategory?.evalutation_ratio) ? '65' : '100') + '%'} >
                                {filterData?.summary !== undefined && filterData?.summary.length > 0 && filterData?.competency_type.length > 0 ?
                                    <Box pl="16px" width="100%" pb="18px" pt="30px">
                                        <Box display="flex" margin="-30px -15px 0" flexWrap="wrap">
                                            {filterData?.summary.map((loRow, index) => (
                                                <Root >
                                                    <Card sx={{ width: "100%" }}>
                                                        <CardContent sx={{ padding: "16px 23px  !important", width: "100%" }}>
                                                            <Box display="flex" container flexWrap="unset">
                                                                <Box
                                                                    item
                                                                    pr="10px"
                                                                    display="flex"
                                                                    alignItems="center"
                                                                    textAlign="left"
                                                                    minHeight="48px"
                                                                    // flexBasis="max-content !important"
                                                                    // minWidth="max-content !important"
                                                                    width=" calc(100% - 62px)"
                                                                >
                                                                    <Typography fontSize={16} color="#6B6B6B" lineHeight="23px" fontWeight="400" >
                                                                        {loRow?.name}
                                                                    </Typography>
                                                                </Box>
                                                                <Box
                                                                    item
                                                                    display="flex"
                                                                    alignItems="center"
                                                                    justifyContent="center"
                                                                    width="62px"
                                                                >
                                                                    <Typography width="62px" fontSize={36} lineHeight="48px" color="primary" textAlign="center">{loRow?.total}</Typography>
                                                                </Box>
                                                            </Box>
                                                        </CardContent>
                                                    </Card>
                                                </Root>
                                            ))}
                                        </Box>
                                    </Box>
                                    : null
                                }
                            </Box>
                            {dataCustomize?.allcomponentcategory?.evalutation_ratio &&
                                <Box width="35%" pr="32px" >
                                    <Card sx={{ height: 1, "box-shadow": "0px 0px 4px rgba(0, 0, 0, 0.1)", "border-radius": "5px" }} >
                                        <EvaluationRatio datas={dataCustomize?.allcomponentcategory?.evalutation_ratio} title={t('competency.label.categoryWeight')} />
                                    </Card>
                                </Box>
                            }
                        </Grid>

                        {filterData?.competency_type !== undefined && filterData?.competency_type !== null && filterData?.competency_type.length > 0 ?
                            <>
                                <Grid container >
                                    <Grid item md={12} >
                                        {competencyFormSelect?.length > 0 ?
                                            <Grid container item mt={"12px"}>
                                                <Grid
                                                    item
                                                    md={6}
                                                    display="flex"
                                                    alignItems="center"
                                                    flexDirection="row"
                                                >
                                                    <Box sx={{ height: "45px", "margin-left": "16px", background: "#74C1ED", "border-radius": "5px", padding: "10px" }}>
                                                        <img src={myCompetencies} alt="myGoals" style={{ height: "25px" }} />
                                                    </Box>
                                                    <Box pl="20px">
                                                        <Typography variant="h2" fontSize={30} lineHeight="33px" color="#404349">
                                                            {t('competency.competencyLists')}
                                                        </Typography>
                                                        {/* <Typography fontSize={14} fontWeight="fontWeightLight" variant="label">
                                                    {`Total competencies: ${filterData?.competency_type !== undefined && filterData?.competency_type !== null ? filterData?.competency_type.length : "0"} competencies`}
                                                </Typography> */}
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                            : null}
                                    </Grid>
                                </Grid>
                                <Grid item lg={12} md={12}>
                                    <Grid item md={12} sx={{ borderBottom: "1px solid #e4e4e4" }} mb="30px">
                                        <Grid container item alignItems="center">
                                            <Tabs
                                                value={value}
                                                indicatorColor="primary"
                                                textColor="primary"
                                                onChange={handleChange}
                                                aria-label="Tabs"
                                                TabIndicatorProps={{
                                                    style: {
                                                        height: "8px",
                                                        fontSize: "20px",
                                                    },
                                                }}
                                            >
                                                <Tab sx={{ fontWeight: "400" }} label={t('label.all') + ` (${sumData()})`} value="all" classes={{ root: classes.tab }} />
                                                {filterData?.competency_type !== undefined && filterData?.competency_type !== null && filterData?.competency_type.length > 0 ? filterData?.competency_type.map((loRow) => (
                                                    <Tab sx={{ fontWeight: "400" }} label={loRow?.name + ` (` + loRow?.total + `)`} value={loRow?.code} classes={{ root: classes.tab }} />
                                                ))
                                                    : null}
                                            </Tabs>
                                        </Grid>
                                    </Grid>
                                    <Grid item sm={12} xs={12} pb="30px" sx={{ display: "flex", "flex-flow": "row", "justify-content": "space-between" }}>
                                        <TextField
                                            id="input-with-icon-textfield"
                                            fullWidth
                                            placeholder={t('label.search')}
                                            size="small"
                                            sx={{ background: "#fff", width: "400px", "input": { padding: "11px 14px" } }}
                                            className="searchTextField-h40"
                                            value={search}
                                            onChange={handleSearch}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <Search style={{ color: "#C4C4C4" }} />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                        <MenuFilter statusOpen={statusOpen} openMenu={openMenu} notEvaluated={notEvaluated} evaluated={evaluated} EditEvaluated={EditNotEvaluated} />
                                    </Grid>
                                    {filterData?.competency_type !== undefined && filterData?.competency_type !== null && filterData?.competency_type.length > 0 ? filterData?.competency_type.map((loRow, index) => (
                                        <>
                                            <Grid container sx={{ display: value === loRow?.code || value === 'all' ? 'block' : 'none' }} pb={5}>
                                                <Grid item lg={12}>
                                                    <Toolbar color="primary" sx={{ "background-color": loRow?.color !== undefined ? loRow?.color : "", color: "#FFFFFF", "box-shadow": "0px 2px 2px rgba(0, 0, 0, 0.1)", "border-radius": "5px", fontWeight: "500" }}>
                                                        <Box sx={{ "align-items": "center", display: "flex", "flex-direction": "row" }}>
                                                            <Box sx={{ width: "50px", "align-items": "center", display: "flex", "flex-direction": "row" }}>
                                                                <Icon sx={{ color: "#ffffff", "font-size": "30px" }}> {loRow?.icon} </Icon>
                                                                {/* <img style={{ width: "auto", height: "30px" }} src={loRow?.icon} alt="iconBar"></img> */}
                                                            </Box>
                                                            <Typography variant="h4_hilight" sx={{ "background-color": loRow?.color !== undefined ? loRow?.color : "", color: "#FFFFFF", fontSize: "24px", lineHeight: "26.4px" }}>
                                                                {formatData(loRow?.name, "-")}
                                                            </Typography>
                                                        </Box>
                                                        <Box sx={{ flexGrow: 1 }} />
                                                        <Box sx={{ padding: "6px 16px", "border-radius": "4px", "min-width": "64px", "border-radius": "4px", border: "1px solid #fff", fontSize: "18px", lineHeight: "26.91px" }} variant="toolbar"><Typography>{loRow?.weight}%</Typography></Box>
                                                    </Toolbar>
                                                    {loRow?.name !== undefined && loRow?.name !== "" ?
                                                        <Box mt={2.5} mb={2.5} sx={{ display: "flex", "flex-direction": "row", "justify-content": "space-between" }}>
                                                            <Typography fontSize={18} fontWeight="400" variant="label" color="#A3A3A3">
                                                                {formatData(loRow?.name, "-")}: <span style={{ color: '#5DA196' }}> {formatData(loRow?.total, "0")}</span> {t('competency.competencies')}
                                                            </Typography>
                                                            {loRow?.total > 4 && value === "all" ?
                                                                <Box sx={{ display: "flex", "flex-direction": "row", "align-items": "center", cursor: "pointer" }}>
                                                                    <Typography onClick={e => navigate(serial !== undefined && serial !== null ? `/kpi/competency/seeall/${loRow.code}/${competencyFormSelectValue}/${serial}` : `/kpi/competency/seeall/${loRow.code}/${competencyFormSelectValue}`, { replace: false })} fontSize={14} fontWeight="400" color="primary" sx={{ transition: "color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms", '&:hover': { color: 'rgb(65, 112, 105) !important' } }}>
                                                                        {t('competency.seeAll')} <ArrowRight style={{ "margin-left": "8px" }} />
                                                                    </Typography>
                                                                </Box>
                                                                : null
                                                            }
                                                        </Box>
                                                        : null
                                                    }
                                                </Grid>
                                                {filterData?.list[loRow.code] !== undefined && filterData?.list[loRow.code].length > 0 ?
                                                    <Box item sx={{ display: "flex", "flex-flow": "row wrap", margin: "-15px -15px" }} >
                                                        {filterData?.list[loRow.code].map((rs, order) =>
                                                            value === "all" ?
                                                                order <= 3 ? (
                                                                    <Box item sx={styles.box} onClick={e => navigate(serial !== undefined && serial !== null ? `/kpi/competency/detail/${rs.serial}/${serial}` : `/kpi/competency/detail/${rs.serial}`, { replace: false })}>
                                                                        <Box sx={styles.content}>
                                                                            <Box sx={{ display: "flex", "justify-content": "space-between", "align-items": "flex-start" }}>
                                                                                <Box>
                                                                                    <Typography fontSize={20} fontWeight="500" color="#404349"
                                                                                        sx={{
                                                                                            wordBreak: "break-word",
                                                                                            overflow: "hidden",
                                                                                            textOverflow: "ellipsis",
                                                                                            display: "-webkit-box",
                                                                                            WebkitLineClamp: "2",
                                                                                            WebkitBoxOrient: "vertical",
                                                                                        }}>
                                                                                        {formatData(rs.name, "-")}
                                                                                    </Typography>
                                                                                    <Typography fontSize={16} fontWeight="400" color="#404349">
                                                                                        {formatData(rs.code, "-")}
                                                                                    </Typography>
                                                                                </Box>
                                                                                {rs?.is_evaluate === true ?
                                                                                    <Box sx={{ width: "190px", minWidth: "190px" }}>
                                                                                        <Box sx={{ background: "rgba(93, 161, 150, 0.1)", "border-radius": "5px", padding: "8px 44px", textAlign: "center" }}>
                                                                                            <Typography fontSize={16} fontWeight="400" variant="label" color="primary" >
                                                                                                {t('competency.evaluated')}
                                                                                            </Typography>
                                                                                        </Box>
                                                                                    </Box>
                                                                                    : null}
                                                                            </Box>
                                                                            <Box sx={{ "padding-top": "15px", "padding-bottom": "15px", }}>
                                                                                <Divider />
                                                                            </Box>
                                                                            {rs?.proficiency !== undefined && rs?.proficiency !== null && rs?.proficiency !== "" ?
                                                                                <Box sx={{ "padding-bottom": "15px", display: "flex", "justify-content": "space-between", "align-items": "center" }}>
                                                                                    <Box sx={{ width: "33.33%" }}>
                                                                                        <Typography fontSize={18} fontWeight="400" variant="label" color="#A3A3A3">
                                                                                            {t('competency.proficiency')}:
                                                                                        </Typography>
                                                                                    </Box>
                                                                                    <Box sx={{ width: "66.67%" }}>
                                                                                        <Typography fontSize={18} fontWeight="400" color="#404349">
                                                                                            {t('competency.level')} {formatData(rs?.proficiency?.level, "-")} - {formatData(rs?.proficiency?.description, "-")}
                                                                                        </Typography>
                                                                                    </Box>
                                                                                </Box>
                                                                                : null
                                                                            }
                                                                            <Box sx={{ display: "flex", "justify-content": "space-between", "align-items": "flex-start" }}>
                                                                                <Box sx={{ width: "33.33%" }}>
                                                                                    <Typography fontSize={18} fontWeight="400" variant="label" color="#A3A3A3">
                                                                                        {t('competency.expectedRating')}:
                                                                                    </Typography>
                                                                                </Box>
                                                                                {rs?.expected_rating?.value !== undefined && rs?.expected_rating?.value !== null && rs?.expected_rating?.value !== "" ?
                                                                                    <Box sx={{ width: "66.67%", display: "flex", 'align-items': "center", }}>
                                                                                        <StyledRating fontSize={19} sx={{ root: styles.emptyStar }} readOnly name="customized-10" precision={0.5} defaultValue={formatData(Number(rs?.expected_rating?.value).toFixed(1), 0)} max={1} />
                                                                                        <Typography fontSize={18} pl="5px" pr="13px" fontWeight="400" color="#404349">
                                                                                            {formatData(Number(formatData(rs?.expected_rating?.value, "0")).toFixed(1), "0")}
                                                                                        </Typography>
                                                                                        <Box sx={{ width: "100%", position: "relative" }}>
                                                                                            <div style={{ width: "max-content" }}>
                                                                                                <BootstrapTooltip
                                                                                                    // PopperProps={{
                                                                                                    //     disablePortal: true,
                                                                                                    // }}
                                                                                                    // style={{ width: "max-content" }}
                                                                                                    // onClose={e => handleTooltipOpen(rs?.serial)}
                                                                                                    // open={open === true && valueSerial === rs?.serial ? true : false}
                                                                                                    placement="right"
                                                                                                    arrow
                                                                                                    // disableFocusListener
                                                                                                    // disableHoverListener
                                                                                                    // disableTouchListener
                                                                                                    title={<span dangerouslySetInnerHTML={{ __html: formatData(rs?.expected_rating?.description, "-") }} />}
                                                                                                >
                                                                                                    <TooltipIcon />
                                                                                                </BootstrapTooltip>
                                                                                                {/* <div className='tooltip' onClick={e => handleTooltipOpen(rs?.serial)} style={{ width: "14px", height: "100%", position: "absolute", top: 0 }}></div> */}
                                                                                            </div>
                                                                                        </Box>
                                                                                    </Box>
                                                                                    :
                                                                                    <Box sx={{ width: "66.67%", display: "flex", 'align-items': "center", }}>
                                                                                        <Typography fontSize={18} pl="5px" pr="13px" fontWeight="400" color="#404349">
                                                                                            {formatData(rs?.expected_rating?.value, "-")}
                                                                                        </Typography>
                                                                                    </Box>
                                                                                }
                                                                            </Box>
                                                                            <Box sx={{ "padding-top": "15px", "padding-bottom": "15px", display: "flex", "justify-content": "space-between", "align-items": "flex-start" }}>
                                                                                <Box sx={{ width: "33.33%" }}>
                                                                                    <Typography fontSize={18} fontWeight="400" variant="label" color="#A3A3A3">
                                                                                        {t('competency.category')}:
                                                                                    </Typography>
                                                                                </Box>
                                                                                <Box sx={{ width: "66.67%" }} style={styles.boxTwoContent}>
                                                                                    <Box>
                                                                                        <Typography fontSize={18} fontWeight="400" color="#404349">
                                                                                            {formatData(rs?.category, "-")}
                                                                                        </Typography>
                                                                                    </Box>
                                                                                    <Box sx={styles.twoContent}>
                                                                                        <BootstrapTooltip title={`${t('competency.achievementActivity')}: ${formatData(rs?.achievement_count, "0")}`} placement="top">
                                                                                            <ListFile style={{ cursor: "pointer" }} />
                                                                                        </BootstrapTooltip>
                                                                                        <Typography pl={1} pr={2} fontSize={16} color="#A3A3A3" fontWeight="400" component="span">
                                                                                            {formatData(rs?.achievement_count, "0")}
                                                                                        </Typography>
                                                                                    </Box>
                                                                                </Box>
                                                                            </Box>
                                                                            {/* <Box sx={{ display: "flex", "justify-content": "space-between", "align-items": "flex-start" }}>
                                                                                <Box sx={{ width: "33.33%" }}>
                                                                                    <Typography fontSize={18} fontWeight="400" variant="label">
                                                                                        {t('competency.evaluationWeight')}:
                                                                                    </Typography>
                                                                                </Box>
                                                                                <Box sx={{ width: "66.67%" }} style={styles.boxTwoContent}>
                                                                                    <Box>
                                                                                        <Typography fontSize={18} fontWeight="400">
                                                                                            {formatData(rs?.evaluation_weight, "-") !== "-" ? `${rs?.evaluation_weight}%` : "-"}
                                                                                        </Typography>
                                                                                    </Box>
                                                                                    <Box sx={styles.twoContent}>
                                                                                        <BootstrapTooltip title={`${t('competency.achievementActivity')}: ${formatData(rs?.achievement_count, "0")}`} placement="top">
                                                                                            <ListFile style={{ cursor: "pointer" }} />
                                                                                        </BootstrapTooltip>
                                                                                        <Typography pl={1} pr={2} fontSize={16} color="#A3A3A3" fontWeight="400" component="span">
                                                                                            {formatData(rs?.achievement_count, "0")}
                                                                                        </Typography>
                                                                                    </Box>
                                                                                </Box>
                                                                            </Box> */}
                                                                        </Box>
                                                                    </Box>
                                                                )
                                                                    :
                                                                    null
                                                                : (
                                                                    <Box item sx={styles.box} onClick={e => navigate(serial !== undefined && serial !== null ? `/kpi/competency/detail/${rs.serial}/${serial}` : `/kpi/competency/detail/${rs.serial}`, { replace: false })}>
                                                                        <Box sx={styles.content}>
                                                                            <Box sx={{ display: "flex", "justify-content": "space-between", "align-items": "flex-start" }}>
                                                                                <Box>
                                                                                    <Typography fontSize={20} fontWeight="500" color="#404349">
                                                                                        {formatData(rs.name, "-")}
                                                                                    </Typography>
                                                                                    <Typography fontSize={16} fontWeight="400" color="#404349">
                                                                                        {formatData(rs.code, "-")}
                                                                                    </Typography>
                                                                                </Box>
                                                                                <Box>
                                                                                    {rs?.is_evaluate === true ?
                                                                                        <Box sx={{ background: "rgba(93, 161, 150, 0.1)", "border-radius": "5px", padding: "8px 44px", }}>
                                                                                            <Typography fontSize={16} fontWeight="400" variant="label" color="primary" >
                                                                                                {t('competency.evaluated')}
                                                                                            </Typography>
                                                                                        </Box>
                                                                                        : null}
                                                                                </Box>
                                                                            </Box>
                                                                            <Box sx={{ "padding-top": "15px", "padding-bottom": "15px", }}>
                                                                                <Divider />
                                                                            </Box>
                                                                            {rs?.proficiency !== undefined && rs?.proficiency !== null && rs?.proficiency !== "" ?
                                                                                <Box sx={{ "padding-bottom": "15px", display: "flex", "justify-content": "space-between", "align-items": "center" }}>
                                                                                    <Box sx={{ width: "33.33%" }}>
                                                                                        <Typography fontSize={18} fontWeight="400" variant="label" color="#A3A3A3">
                                                                                            {t('competency.proficiency')}:
                                                                                        </Typography>
                                                                                    </Box>
                                                                                    <Box sx={{ width: "66.67%" }}>
                                                                                        <Typography fontSize={18} fontWeight="400" color="#404349">
                                                                                            {t('competency.level')} {formatData(rs?.proficiency?.level, "-")} - {formatData(rs?.proficiency?.description, "-")}
                                                                                        </Typography>
                                                                                    </Box>
                                                                                </Box>
                                                                                : null
                                                                            }
                                                                            <Box sx={{ display: "flex", "justify-content": "space-between", "align-items": "flex-start" }}>
                                                                                <Box sx={{ width: "33.33%" }}>
                                                                                    <Typography fontSize={18} fontWeight="400" variant="label" color="#A3A3A3">
                                                                                        {t('competency.expectedRating')}:
                                                                                    </Typography>
                                                                                </Box>
                                                                                {rs?.expected_rating?.value !== undefined && rs?.expected_rating?.value !== null && rs?.expected_rating?.value !== "" ?
                                                                                    <Box sx={{ width: "66.67%", display: "flex", 'align-items': "center", }}>
                                                                                        <StyledRating fontSize={19} sx={{ root: styles.emptyStar }} readOnly name="customized-10" precision={0.5} defaultValue={formatData(Number(rs?.expected_rating?.value).toFixed(1), 0)} max={1} />
                                                                                        <Typography fontSize={18} pl="5px" pr="13px" fontWeight="400" color="#404349">
                                                                                            {formatData(Number(formatData(rs?.expected_rating?.value, "0")).toFixed(1), "0")}
                                                                                        </Typography>
                                                                                        <Box sx={{ width: "100%", position: "relative" }}>
                                                                                            <div style={{ width: "max-content" }}>
                                                                                                <BootstrapTooltip
                                                                                                    // PopperProps={{
                                                                                                    //     disablePortal: true,
                                                                                                    // }}
                                                                                                    // style={{ width: "max-content" }}
                                                                                                    // onClose={e => handleTooltipOpen(rs?.serial)}
                                                                                                    // open={open === true && valueSerial === rs?.serial ? true : false}
                                                                                                    placement="right"
                                                                                                    arrow
                                                                                                    // disableFocusListener
                                                                                                    // disableHoverListener
                                                                                                    // disableTouchListener
                                                                                                    title={<span dangerouslySetInnerHTML={{ __html: formatData(rs?.expected_rating?.description, "-") }} />}
                                                                                                >
                                                                                                    <TooltipIcon />
                                                                                                </BootstrapTooltip>
                                                                                                {/* <div className='tooltip' onClick={e => handleTooltipOpen(rs?.serial)} style={{ width: "14px", height: "100%", position: "absolute", top: 0 }}></div> */}
                                                                                            </div>
                                                                                        </Box>
                                                                                    </Box>
                                                                                    :
                                                                                    <Box sx={{ width: "66.67%", display: "flex", 'align-items': "center", }}>
                                                                                        <Typography fontSize={18} pl="5px" pr="13px" fontWeight="400" color="#404349">
                                                                                            {formatData(rs?.expected_rating?.value, "-")}
                                                                                        </Typography>
                                                                                    </Box>
                                                                                }
                                                                            </Box>
                                                                            <Box sx={{ "padding-top": "15px", "padding-bottom": "15px", display: "flex", "justify-content": "space-between", "align-items": "flex-start" }}>
                                                                                <Box sx={{ width: "33.33%" }}>
                                                                                    <Typography fontSize={18} fontWeight="400" variant="label" color="#A3A3A3">
                                                                                        {t('competency.category')}:
                                                                                    </Typography>
                                                                                </Box>
                                                                                <Box sx={{ width: "66.67%" }} style={styles.boxTwoContent}>
                                                                                    <Box>
                                                                                        <Typography fontSize={18} fontWeight="400" color="#404349">
                                                                                            {formatData(rs?.category, "-")}
                                                                                        </Typography>
                                                                                    </Box>
                                                                                    <Box sx={styles.twoContent}>
                                                                                        <BootstrapTooltip title={`${t('competency.achievementActivity')}: ${formatData(rs?.achievement_count, "0")}`} placement="top">
                                                                                            <ListFile style={{ cursor: "pointer" }} />
                                                                                        </BootstrapTooltip>
                                                                                        <Typography pl={1} pr={2} fontSize={16} color="#A3A3A3" fontWeight="400" component="span">
                                                                                            {formatData(rs?.achievement_count, "0")}
                                                                                        </Typography>
                                                                                    </Box>
                                                                                </Box>
                                                                            </Box>
                                                                        </Box>
                                                                    </Box>
                                                                )
                                                        )}
                                                    </Box>
                                                    :
                                                    <Grid item sx={styles.emty} >
                                                        <img src={emty} alt="emtyData"></img>
                                                        <Typography pt={1} fontSize={16} fontWeight="fontWeightLight" variant="label">{t('competency.notBeenAssigned')}</Typography>
                                                    </Grid>
                                                }
                                            </Grid>
                                        </>
                                    ))
                                        : null
                                    }
                                </Grid>
                            </>
                            :
                            <Grid container spacing={2} mt={0}>
                                <Grid item lg={12} md={12}>
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        flexDirection="column"
                                        p={1}
                                        sx={{ minHeight: "400px" }}
                                    >
                                        <Box>
                                            <img src={fileBrowser} alt="browser" />
                                        </Box>
                                        <Box>
                                            <Typography variant="sub_label">{t('competency.nodata')}</Typography>
                                        </Box>
                                    </Box>
                                </Grid>
                            </Grid>
                        }
                    </Grid>
                </Container>
            </Box>
        </Box>
    )
};
export default Planing;
